import axios from 'axios'

export default {
    async get(startNum) {
        try {
            const response = await axios.get(`Notifications/${startNum}`)            
            return response
        }catch(error){
            console.log('Notifications api get error')
            throw error
        }
    },
    async getUnread() {
        try {
            const response = await axios.get(`Notifications/unread`)            
            return response
        }catch(error){
            console.log('Notifications api getUnread error')
            throw error
        }
    },
    async clicked(data) {
        try {
            const response = await axios.post(`Notifications/clicked`,{
                item: data
            })            
            return response
        }catch(error){
            console.log('Notifications api clicked error')
            throw error
        }
    },
    async sendCommentsNotification(data) {
        try {
            const response = await axios.post(`Notifications/comments`, {
                item : data
            })            
            return response
        }catch(error){
            console.log('Notifications api sendCommentsNotification error')
            throw error
        }
    },
    async markAllUnRead() {
        try {
            const response = await axios.post(`Notifications/unread-all`)            
            return response
        }catch(error){
            console.log('Notifications api markAllUnRead error')
            throw error
        }
    },
    async markAllRead() {
        try {
            const response = await axios.post(`Notifications/read-all`)            
            return response
        }catch(error){
            console.log('Notifications api markAllUnRead error')
            throw error
        }
    },
    async getMyReminders() {
        try {
            const response = await axios.get(`Notifications/reminders`)            
            return response
        }catch(error){
            console.log('Notifications api getMyReminders error')
            throw error
        }
    },
}
